import axiosInstance from "./api_helper";

const dalaService = {

    /* ===============================
       LIST DALAS
    =============================== */
    list: async (params = {}) => {
        return axiosInstance.get('/api/dalas', { params });
    },

    /* ===============================
       GET ONE DALA
    =============================== */
    getById: async (id) => {
        return axiosInstance.get(`/api/dalas/${id}`);
    },

    /* ===============================
       SAVE DALA (CREATE)
    =============================== */
    save: async (payload) => {
        return axiosInstance.post('/api/dalas', payload);
    },

    /* ===============================
       UPDATE DALA
    =============================== */
    update: async (id, data) => {
        return axiosInstance.put(`/api/dalas/${id}`, JSON.stringify(data));
    },

    /* ===============================
       DELETE DALA
    =============================== */
    delete: async (id) => {
        return axiosInstance.delete(`/api/dalas/${id}`);
    },

    /* ===============================
       CALCULATE DALA (OPTIONAL)
       👉 si tu veux faire calcul backend
    =============================== */
    calculate: async (payload) => {
        return axiosInstance.post('/api/dalas/calculate', payload);
    },

    /* ===============================
       GET DALAS BY CLIENT
    =============================== */
    getByClient: async (clientId) => {
        return axiosInstance.get(`/api/dalas/client/${clientId}`);
    },

    /* ===============================
       GENERATE PDF DEVIS
    =============================== */
    generatePdf: async (id) => {
        return axiosInstance.get(`/api/dalas/${id}/pdf`, {
            responseType: 'blob'
        });
    },

    /* ===============================
       DUPLICATE DALA
    =============================== */
    duplicate: async (id) => {
        return axiosInstance.post(`/api/dalas/${id}/duplicate`);
    },

};

export default dalaService;
